export default "__VITE_ASSET__CMAC3E$z__"